import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Header from "./components/Header";
import MemeLibrary from "./components/MemeLibrary";
import MemeEditor from "./components/MemeEditor";
import { MemeTemplateProvider } from "./context/MemeTemplateContext";

const theme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: "#818cf8",
    },
    secondary: {
      main: "#94a3b8",
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 700,
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <MemeTemplateProvider>
        <Router>
          <div className="flex flex-col min-h-screen bg-gray-900">
            <Header />
            <main className="flex-grow container mx-auto px-4 py-6">
              <Routes>
                <Route path="/" element={<MemeLibrary />} />
                <Route path="/editor/:id" element={<MemeEditor />} />
              </Routes>
            </main>
            <footer className="bg-gray-800 py-4 text-center text-gray-400">
              <p>MemeGen - Create and share memes with ease</p>
            </footer>
          </div>
        </Router>
      </MemeTemplateProvider>
    </ThemeProvider>
  );
}

export default App;
